// import './LeftNav.scss';
import { KeyboardDoubleArrowDown } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useSnackbar } from 'notistack';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import CompanyAdminNavTruck from '../../assets/images/client-admin-nav.svg';
import LogoNav2 from '../../assets/images/logo-nav2.svg';
import Logo from '../../assets/images/logoNav.svg';
import NavTruck from '../../assets/images/nav-truck.svg';
// import { PrivateRoutes } from '../../config';
import { useCustomStore } from '../../hooks';
import { CustomAppPage } from '../../types';
import { AccessTypes } from '../../types';
import { SnackBarConfig } from '../../utils/SnackBarConfig';
import Storage from '../../utils/Storage';
import { Pages } from './AppPages';
import useStyles from './LeftNavStyles';

type ExpandToggler = {
  servicerequest: boolean;
};

/* const profileRoute: any = {
  haschildren: false,
  icon: '/assets/images/n-dashboard.svg',
  route: PrivateRoutes.PROFILE,
  title: 'Profile',
  whiteIcon: '',
};*/

const LeftNav: React.FC = (props) => {
  const { authStore, globalStore, userStore }: any = useCustomStore();
  const { enqueueSnackbar } = useSnackbar();

  const useNavigator = useNavigate();
  const history = useLocation();
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState<ExpandToggler>({
    servicerequest: false,
  });

  const [loginUser, setLoginUser] = React.useState<any>({
    accountName: '',
    name: '',
  });

  const onLogout = useCallback(() => {
    authStore.logout();
    Storage.clear();
  }, [authStore]);

  const logoutPage = {
    aicon: '/assets/images/n-logout.svg',
    caicon: '/assets/images/n-logout.svg',
    haschildren: false,
    icon: '/assets/images/n-logout.svg',
    onClick: onLogout,
    roles: [
      AccessTypes.CompanyAdmin,
      AccessTypes.OwnerOperator,
      AccessTypes.Driver,
    ],
    route: '',
    show: true,
    title: 'Log Out',
    whiteIcon: '',
  };

  const handleChange = (panel: string) => (event: any, isExpanded: any) => {
    // setExpanded(isExpanded ? panel : false);
    setExpanded((p) => ({
      ...p,
      [panel]: isExpanded,
    }));
  };

  const disableAccess = useCallback(
    (title: string) => {
      if (authStore?._sidNav?.training) {
        return (
          title === 'Training' &&
          !authStore._sidNav?.training?.assigned &&
          !authStore._sidNav?.training?.completed &&
          !authStore._sidNav?.training?.recommended
        );
      } else {
        return false;
      }
    },
    [authStore._sidNav?.training],
  );

  useEffect(() => {
    // if (!globalStore.getCurrentRoute) {
    globalStore.setCurrentRoute(history.pathname);
    const historyPath: any = (history.pathname || '').split('/');

    if (historyPath[1]) {
      const expandKeys: string[] = Object.keys({ ...expanded });
      const mainContentRoute = (historyPath[1] || '').replace(/-/gim, '');
      const expandedModifiedData: any = {};
      expandKeys.forEach((key: any) => {
        expandedModifiedData[key] = false;
      });
      if (expandKeys.includes(mainContentRoute)) {
        expandedModifiedData[mainContentRoute] = true;
      }
      setExpanded((p) => ({
        ...p,
        ...expandedModifiedData,
      }));
    }
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalStore.getCurrentRoute]);

  useEffect(() => {
    getUserDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getUserDetail = useCallback(async () => {
    const userDetailResponse = await userStore.fetchUsersProfilelInfo();
    if (userDetailResponse.isOk()) {
      const { value } = userDetailResponse;
      setLoginUser({ ...value });
    }

    if (userDetailResponse.isErr()) {
      const {
        error: { message = null },
      } = userDetailResponse;
      if (typeof message === 'string') {
        enqueueSnackbar(
          message || 'Error while processing data',
          SnackBarConfig('e'),
        );
      } else if (typeof message === 'object') {
        const messages: any = {};
        Object.keys(message).forEach((key) => {
          messages[key] = message[key].message;
        });

        Object.keys(messages).forEach((msg: string) => {
          const key: string = msg;
          const value: string = messages[msg];

          enqueueSnackbar(`${key} : ${value}`, SnackBarConfig('e'));
        });
      } else {
        enqueueSnackbar('Error while processing data', SnackBarConfig('e'));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let appPages: CustomAppPage[] = React.useMemo(() => [], []);
  let appPagesUsr: string = React.useMemo(() => '', []);

  if (authStore.tokens) {
    const role = authStore.getTokenDetail?.accessType || '';
    const adminPages = Pages.AdminPages(authStore.NavbarAccess);
    adminPages.push(logoutPage);
    appPages = adminPages
      .filter((ele) => {
        if (ele.haschildren) {
          ele.childrens = ele.childrens?.filter((val) => val.show);
        }
        return ele.show;
      })
      .filter((ele) => ele.roles?.includes(role));
    if (role === AccessTypes.CompanyAdmin) {
      appPagesUsr = 'Company';
    } else if (role === AccessTypes.Driver) {
      appPagesUsr = 'Driver';
    } else if (role === AccessTypes.OwnerOperator) {
      appPagesUsr = 'Owner Operator';
    }
  }

  const checkRouteDefiner = (childRoute: any) => {
    if (
      !childRoute ||
      !childRoute.subRouteList ||
      (Array.isArray(childRoute.subRouteList) &&
        !childRoute.subRouteList.length)
    ) {
      return false;
    }

    return childRoute.subRouteList.includes(globalStore.getCurrentRoute);
  };

  const NavigateRoute = (route: CustomAppPage, status: string) => {
    useNavigator(route.route);
    globalStore.setCurrentRoute(route.route);
    globalStore.setMenu(false);
    if (status === 'parent') {
      setExpanded({
        servicerequest: false,
      });
    }
  };

  const getMailContentSideNavHighlightStatus = (route: any) => {
    if (
      route.subRouteList &&
      Array.isArray(route.subRouteList) &&
      route.subRouteList.length
    ) {
      return route.subRouteList.includes(globalStore.getCurrentRoute);
    }
    return route.route === globalStore.getCurrentRoute;
  };

  const sideNavDecider = () => {
    return true;
  };

  const menuBoxRef = useRef<HTMLDivElement>(null);
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);

  const handleMenuScroll = () => {
    const el = menuBoxRef.current;
    if (!el) return;

    setShowScrollIndicator(
      el.scrollTop + el.clientHeight < el.scrollHeight - 2,
    );
  };

  useEffect(() => {
    const el = menuBoxRef.current;
    if (!el) return;
    setShowScrollIndicator(
      el.scrollTop + el.clientHeight < el.scrollHeight - 2,
    );
    el.addEventListener('scroll', handleMenuScroll);
    window.addEventListener('resize', handleMenuScroll);
    return () => {
      el.removeEventListener('scroll', handleMenuScroll);
      window.removeEventListener('resize', handleMenuScroll);
    };
  }, []);

  // Company Portal
  return (
    <div
      className={classes.sidebar}
      style={{
        backgroundColor: sideNavDecider() ? '#d1d3d4' : '#241a2e',
        backgroundImage: `url(${
          sideNavDecider() ? CompanyAdminNavTruck : NavTruck
        })`,
      }}>
      <img
        className={classes.logo}
        src={sideNavDecider() ? LogoNav2 : Logo}
        alt="Simplex Group"
      />
      <div
        className={sideNavDecider() ? classes.companyPortal : classes.portal}>
        {appPagesUsr} Portal{' '}
        {authStore.getTokenDetail && authStore.getTokenDetail?.adminId
          ? '(Impersonating)'
          : ''}
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className={classes.menuBox}
          ref={menuBoxRef}
          style={{
            maxHeight: 'calc(100vh - 220px)',
            overflowY: 'auto',
            ...(classes.menuBox && typeof classes.menuBox === 'object'
              ? classes.menuBox
              : {}),
          }}>
          {appPages.map((route, index) => {
            let hignLightClassName = classes.menuItem;
            let menuText: any = 'menu-text';

            if (sideNavDecider()) {
              hignLightClassName = classes.CompanyMenuItem;
              menuText = 'company-menu-text';
            }

            if (route.haschildren) {
              const expandname: any = route.routename || '';
              const expandList: any = { ...expanded };
              const expandStatus: boolean = expandList[expandname] || false;
              const initialRoute: string =
                globalStore.getCurrentRoute.split('/');
              let toggleClassName: any = '';
              if (
                route.route &&
                initialRoute[1] &&
                route.route === `/${initialRoute[1]}`
              ) {
                if (sideNavDecider()) {
                  hignLightClassName = clsx(
                    classes.companyActiveItem,
                    classes.CompanyMenuItem,
                  );
                } else {
                  hignLightClassName = clsx(
                    classes.activeItem,
                    classes.menuItem,
                  );
                }
              }

              if (expandStatus) {
                if (sideNavDecider()) {
                  toggleClassName = 'company-active-toggle';
                } else {
                  toggleClassName = 'active-toggle';
                }
              }

              const imageHighLight = (routes: any) => {
                let allChildrenSubRoutes: any[] = [];
                routes.childrens.forEach((subroute: any) => {
                  if (
                    subroute.subRouteList &&
                    Array.isArray(subroute.subRouteList) &&
                    subroute.subRouteList.length
                  ) {
                    allChildrenSubRoutes = [
                      ...allChildrenSubRoutes,
                      ...subroute.subRouteList,
                    ];
                  }
                });
                return allChildrenSubRoutes.includes(
                  globalStore.getCurrentRoute,
                );
              };

              return (
                <Accordion
                  key={index}
                  expanded={expandStatus}
                  onChange={handleChange(expandname)}
                  className={toggleClassName}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header">
                    <Typography component={'div'}>
                      <div className="menu-item">
                        {route && imageHighLight(route) ? (
                          <img
                            className="menu-icon"
                            src={sideNavDecider() ? route.caicon : route.aicon}
                            alt="icon"
                          />
                        ) : (
                          <img
                            className="menu-icon"
                            src={route.icon}
                            alt="icon"
                          />
                        )}
                        <div className={menuText}>{route.title}</div>
                      </div>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography component={'div'}>
                      {(route.childrens || []).map((childRoute) => {
                        let subHighLightClassName =
                          'menu-text inner-menu d-flex-a';
                        if (childRoute.route && checkRouteDefiner(childRoute)) {
                          subHighLightClassName += ' a-inner-menu';
                        }
                        return (
                          <div
                            key={childRoute.title}
                            // className="menu-text inner-menu d-flex-a"
                            className={subHighLightClassName}
                            onClick={() => NavigateRoute(childRoute, 'child')}>
                            {childRoute.route &&
                            checkRouteDefiner(childRoute) ? (
                              <div
                                className={
                                  sideNavDecider()
                                    ? 'act-btn companyPortalColor'
                                    : 'act-btn portalColor'
                                }
                              />
                            ) : (
                              <div className="act-btn portalColor hidden" />
                            )}

                            <div>{childRoute.title}</div>
                          </div>
                        );
                      })}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              );
              // return null;
            }
            if (route.route && getMailContentSideNavHighlightStatus(route)) {
              if (sideNavDecider()) {
                hignLightClassName = clsx(
                  classes.companyActiveItem,
                  classes.CompanyMenuItem,
                );
              } else {
                hignLightClassName = clsx(classes.activeItem, classes.menuItem);
              }
            }

            return (
              <React.Fragment key={index}>
                {route.title === 'Settings' && (
                  <div
                    style={{
                      borderTop: sideNavDecider()
                        ? '1px solid #B1B4BE'
                        : '1px solid #3e3548',
                      marginBottom: '1rem',
                      marginLeft: '0.5rem',
                      marginRight: '1rem',
                      marginTop: '2rem',
                    }}
                  />
                )}

                {!disableAccess(route.title) && (
                  <div
                    className={hignLightClassName}
                    onClick={() =>
                      route.onClick
                        ? route.onClick()
                        : NavigateRoute(route, 'parent')
                    }>
                    {route.route &&
                    getMailContentSideNavHighlightStatus(route) ? (
                      <img
                        className="menu-icon"
                        src={sideNavDecider() ? route.caicon : route.aicon}
                        alt="icon"
                      />
                    ) : (
                      <img className="menu-icon" src={route.icon} alt="icon" />
                    )}
                    <div
                      className={
                        sideNavDecider()
                          ? classes.companyMenuText
                          : classes.menuText
                      }>
                      {route.title}
                    </div>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
        {showScrollIndicator && (
          <div
            style={{
              alignItems: 'flex-end',
              background:
                'linear-gradient(to bottom, rgba(255,255,255,0), rgba(0,0,0,0.12))',
              bottom: 0,
              display: 'flex',
              height: 24,
              justifyContent: 'flex-end',
              left: 0,
              pointerEvents: 'none',
              position: 'absolute',
              right: 0,
            }}>
            <KeyboardDoubleArrowDown
              style={{ color: '#888', fontSize: 18, marginBottom: 2 }}
            />
          </div>
        )}
      </div>
      <div
        className={classes.profileBox}
        style={{
          borderTop: sideNavDecider()
            ? '1px solid #B1B4BE'
            : '1px solid #3E3548',
        }}>
        <div className={classes.w90}>
          <div
            className={classes.company}
            style={{
              color: sideNavDecider() ? '#979598' : '#dec330',
            }}>
            {loginUser.accountName || ''}
          </div>
          <div
            className={classes.name}
            style={{
              color: sideNavDecider() ? '#241A2E' : '#FFFFFF',
            }}>
            {loginUser.name || ''}
          </div>
        </div>
      </div>
    </div>
  );
};
export default observer(LeftNav);
